import React from 'react';
import { 
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
} from '@mui/material';
import { Delete as DeleteIcon } from '@mui/icons-material';

function DeleteConfirmationDialog({ open, onClose, selectedItem, isDeleting, onConfirm }) {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <DeleteIcon sx={{ color: '#dc2626' }} />
        Delete Document
      </DialogTitle>
      <DialogContent>
        <Typography variant="body1" sx={{ mt: 1 }}>
          Are you sure you want to delete this document? This action cannot be undone.
        </Typography>
        {selectedItem && (
          <Box sx={{ mt: 2, p: 2, bgcolor: '#f9fafb', borderRadius: 1 }}>
            <Typography variant="body2" sx={{ fontWeight: 500, mb: 1 }}>
              Document: {selectedItem.name || selectedItem.knowledgeBaseId || 'Unnamed Document'}
            </Typography>
            <Typography variant="caption" sx={{ color: '#6b7280', wordBreak: 'break-all' }}>
              {selectedItem.knowledgeBaseUrl}
            </Typography>
          </Box>
        )}
      </DialogContent>
      <DialogActions sx={{ p: 2 }}>
        <Button 
          onClick={onClose} 
          color="inherit"
          disabled={isDeleting}
        >
          Cancel
        </Button>
        <Button 
          onClick={onConfirm} 
          variant="contained"
          disabled={isDeleting}
          sx={{
            backgroundColor: '#dc2626',
            color: '#ffffff',
            '&:hover': { 
              backgroundColor: '#b91c1c'
            },
            '&:disabled': {
              backgroundColor: '#9ca3af'
            }
          }}
        >
          {isDeleting ? 'Deleting...' : 'Delete'}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default DeleteConfirmationDialog;
